import React, { useEffect, useState, useCallback } from 'react';
import envConstants from "../Constants";
import axios from "../Axiosapi";
import { Link } from 'react-router-dom';


const Blogs = () => {
    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);
            try {
                let url = `${envConstants.API_BASE_URL}/blogs`;
                const response = await axios.get(url, { responseType: 'json' });
                // Filter blogs with active status of 1
                const activeBlogs = response.data.data.filter(blog => blog.active === 1);
                setBlogs(activeBlogs);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    if (loading || !blogs) return <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>;

    return (
        <>
            <section class="hero-banner">
                <div class="container">
                    <div class="hero-content">
                        <h1 class="hero-title">Blogs</h1>
                        <p class="hero-subtitle">Explore our collection of carefully crafted articles, insights, and stories that inspire and inform.</p>
                    </div>
                </div>
            </section>
            <section class="blog-section" id="blogs">

                <div class="container">
                    <div class="section-title">
                        <h2>Latest Articles</h2>
                        <p>Stay updated with our latest thoughts, tutorials, and insights from the world of technology and design.</p>
                    </div>

                    <div class="row">
                        {blogs.map((blog) => (
                            <div class="col-lg-4 col-md-6">
                                <div class="blog-card">
                                    <div class="blog-card-image" style={{ backgroundImage: `url(${envConstants.API_BASE_PUBLIC_URL}${blog.featured_images})` }} aria-label={blog.fimage_alt_text}>
                                        <i class="fas fa-code"></i>
                                    </div>
                                    <div class="blog-card-content">
                                        <div class="blog-meta">
                                            <span class="badge">
                                                {new Date(blog.created_at).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                })}</span>
                                        </div>
                                        <Link to={`/blog/${blog.permalink}`} className='text-decoration-none'><h3 class="blog-title">{blog.title}</h3></Link>
                                        <p class="blog-excerpt">{blog.description}</p>
                                        <div class="blog-footer">
                                            <Link to={`/blog/${blog.permalink}`} class="read-more">
                                                Read More <i class="fas fa-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blogs